import { render } from 'react-dom'
import React, { useEffect, useRef } from 'react'
import App from './App'
import useStore from './store'
import './styles.css'
import { TweenMax, Sine, Linear, gsap } from "gsap"


function Overlay() {
  const inside = useRef()
  const progress = useRef()
  const clicked = useStore(state => state.clicked)
  const loaded = useStore(state => state.loaded)
  const loopDur = useStore(state => state.loopDur)
  const set = useStore(state => state.set)
  let loop = () => {
    TweenMax.to(progress.current, 1.5, {
      width: '5vh'
    });
    TweenMax.to(inside.current, loopDur/2, {
      width: '100%',
      yoyo: true,
      repeat: -1,
    });
  }
  useEffect(() => {
    clicked && loop()
  },[clicked])
  return (
      <div className={`top ${loaded ? 'loaded' : 'notready'} ${clicked && 'clicked'}`}>
        <div className="progress" ref={progress} >
          <div className="inside" ref={inside} />
        </div>
      </div>
  )
}

render(
  <>
    <App />
    <Overlay />
  </>,
  document.querySelector('#root'),
)
